// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"ActiveQuiz__ActiveQuiz___lxUZJ","Question":"ActiveQuiz__Question___Flw_y"};